<template>
    <!-- <BModal
        v-model="isOpen"
        :title="`${workExperience.id ? $t('work_experience.edit') : $t('work_experience.add')}`"
        hide-footer 
        modal-class="af-modal work-experience-modal"
        size="lg"
        scrollable
        no-close-on-backdrop
        no-close-on-esc
        @hidden="close"
    > -->
    <C1Modal
        v-if="isModalOpen"
        v-model="isOpen"
        modal-content-class="af-modal work-experience-modal afu-p-4 md:afu-p-8 md:afu-pt-6"
        size="xl"
        @hidden="close"
    >
        <template v-slot:body>
            <div class="afu-flex afu-items-center af-text--4xl afu-text-black afu-mb-8">
                <span class="afu-mr-3 afu-text-900">
                    <FontAwesomeIcon :icon="['far', 'plus']" />
                </span>
                <span class="afu-font-bold">
                    {{ `${workExperience.id ? $t('work_experience.edit') : $t('work_experience.add')}` }}
                </span>
            </div>
            <WorkExperienceForm
                :work-experience="workExperience"
                :hide-description="hideDescription"
                @change="onWorkExperienceChange"
            />
            <div class="afu-text-danger-400 afu-mb-2 afu-text-center">
                {{ error }}
            </div>
            <div class="afu-flex afu-items-center afu-justify-center">
                <C1Button
                    :disable="spinner.destroy"
                    @click="$emit('closeModal')"
                    variant="outline-secondary"
                >
                    {{ $t('label.cancel') }}
                </C1Button>

                <C1Button
                    :is-busy="spinner.save"
                    variant="outline-primary"
                    class="afu-ml-2"
                    @click="save()"
                >
                    {{ $t('label.save_work_experience') }}
                </C1Button>
            </div>
        </template>
    </C1Modal>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import WorkExperienceForm from '@/apps/dashboard/001/components/WorkExperience/WorkExperienceForm';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Modal from '@/components/C1Components/C1Modal';

    export default {
        name: 'WorkExperienceModal',

        components: {
            C1Button,
            WorkExperienceForm,
            C1Modal,
        },

        props: {
            workExperience: {
                type: Object,
                default: () => ({}),
            },

            hideDescription: {
                type: Boolean,
                default: false,
            },

            isModalOpen: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isOpen: false,
                payType: 'Annually',
                form: {},
                brandOptions: [],
                locationOptions: [],
                occupationOptions: [],
                shouldDestroy: false,
                spinner: {
                    destroy: false,
                    save: false,
                },
                error: '',
            };
        },

        created() {},

        beforeDestroy() {},

        methods: {
            ...mapMutations('me', {
                $_STORE_WORK_EXPERIENCE: 'STORE_WORK_EXPERIENCE',
                $_PUT_WORK_EXPERIENCE: 'PUT_WORK_EXPERIENCE',
            }),

            ...mapActions('me', {
                $_getWorkExperiences: 'getWorkExperiences',
                $_storeWorkExperience: 'storeWorkExperience',
                $_updateWorkExperience: 'updateWorkExperience',
            }),

            onWorkExperienceChange(form) {
                this.form = form;
            },

            async save() {
                this.error = '';

                if (this.form?.job_title === '') {
                    this.error = 'Job title is required';
                    return;
                }

                if (this.form?.employer_name === '') {
                    this.error = 'Company is required';
                    return;
                }

                if (this.form?.subclassification?.id === undefined) {
                    this.error = 'Occupation is required';
                    return;
                }

                if (this.form?.end_date === '' && this.form?.is_current == false) {
                    this.error = 'End date is required';
                    return;
                }

                const payload = {
                    job_title: this.form?.job_title || '',
                    classification_id: this.form?.classification?.id || '',
                    subclassification_id: this.form?.subclassification?.id || '',
                    employer_name: this.form?.employer_name || '',
                    brand_id: this.form?.brand_id || '',
                    job_type_id: this.form?.job_type?.id || '',
                    contract_type_id: this.form?.contract_type?.id || '',
                    location_id: this.form?.location_id || '',
                    pay_band_id: this.form?.pay_band?.id || '',
                    is_current: this.form?.is_current || false,
                    start_date: this.form.start_date
                        ? `${this.form.start_date}-01`
                        : '',
                    end_date: this.form.end_date ? `${this.form.end_date}-01` : '',
                    description: this.form?.description || '',
                    log_request_id: this.form?.log_request_id || '',
                };

                if (this.form.id) {
                    this.updateWorkExperience(this.form.id, payload);
                } else {
                    this.storeWorkExperience(payload);
                }
                this.$emit('closeModal');
            },

            storeWorkExperience(data) {
                this.spinner.save = true;
                this.$_storeWorkExperience(data)
                    .then(() => {
                        this.$_getWorkExperiences().then(response => {
                            this.$_STORE_WORK_EXPERIENCE(response.data);
                            this.closeModal();
                        });
                    })
                    .finally(() => {
                        this.spinner.save = false;
                    });
            },

            updateWorkExperience(id, data) {
                this.spinner.save = true;
                this.$_updateWorkExperience({ id, data })
                    .then(response => {
                        this.$_PUT_WORK_EXPERIENCE(response.data);
                        this.closeModal();
                    })
                    .finally(() => {
                        this.spinner.save = false;
                    });
            },

            close() {
                this.$emit('close');
            },

            closeModal() {
                this.close();
            },
        },
    };
</script>
